var Base = require('_js/base'),
  $ = require('jquery'),
  ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

var PasswordModal = function(params) {
  this.closeModalFunc = params.closeModal;
  this.api = params.api;
  this.oldPassword = ko.observable().extend();
  this.newPassword = ko.observable().extend({
    required: [
      { type: 'isNotEmpty', message: 'Feltet kan ikke være tomt' },
      {
        type: 'isMinLength',
        message: 'Feltet må bestå av minst 12 tegn',
        length: 12
      },
      {
        type: 'isRNPassword',
        message:
          'Det nye passordet må bestå av minst 12 tegn, små og store bokstaver og ett eller flere tall'
      }
    ]
  });
  this.confirmPassword = ko.observable().extend({
    required: [
      { type: 'isNotEmpty', message: 'Feltet kan ikke være tomt' },
      {
        type: 'isMinLength',
        message: 'Feltet må bestå av minst 12 tegn',
        length: 12
      },
      {
        type: 'isEqualTo',
        message: 'Feltet stemmer ikke overens med det nye passordet.',
        value: this.newPassword
      },
      {
        type: 'isRNPassword',
        message:
          'Det nye passordet må bestå av minst 12 tegn, små og store bokstaver og ett eller flere tall'
      }
    ]
  });

  this.fields = [this.newPassword, this.confirmPassword];
  this.validationStatus = ko.observable('');
  this.validationText = ko.observable('');
};

PasswordModal.prototype.validateFields = function() {
  var isValid = true;
  for (var i = 0; i < this.fields.length; i++) {
    if (this.fields[i]() === undefined || this.fields[i]() === null) {
      this.fields[i].hasError(true);
    }
    if (this.fields[i].hasError()) {
      isValid = false;
    }
  }

  return isValid;
};

PasswordModal.prototype.changePassword = function() {
  // Check if fields are valid before changing password
  if (!this.validateFields()) {
    return;
  }

  var self = this;

  // Do API call that changes password.
  APIHelper.post(
    this.api,
    {
      aktorId: window.username,
      oldPassword: this.oldPassword(),
      newPassword: this.confirmPassword()
    },
    function() {
      self.validationStatus('success');
    },
    function(data) {
      self.validationStatus('errors');
      self.validationText(data.statusText);
    }
  );
};

PasswordModal.prototype.closeModal = function() {
  this.closeModalFunc();
};

function ProfileHeader() {
  this.init();
  var $passwordModal = $('.change-password-modal');
  if ($passwordModal.get(0) !== undefined) {
    ko.applyBindings(
      new PasswordModal({
        closeModal: this.closeModal.bind(this),
        api: $passwordModal.data('password-api')
      }),
      $passwordModal.get(0)
    );
  }
}

ProfileHeader.prototype = new Base();

ProfileHeader.prototype.init = function() {
  var $passwordBtn = $('.profile-header-password .btn'),
    $passwordModal = $('.change-password-modal'),
    $passwordModalClose = $passwordModal.find('.icon-close');

  $passwordBtn.on('click', function() {
    $passwordModal.toggleClass('is-active');
  });
  $passwordModalClose.on('click', function() {
    $passwordModal.removeClass('is-active');
  });

  this.$passwordModal = $passwordModal;

  $('.profile-content .accordion-single header').on('click', function() {
    $(this)
      .parent()
      .toggleClass('is-active');
  });
};

ProfileHeader.prototype.closeModal = function() {
  this.$passwordModal.removeClass('is-active');
};

module.exports = ProfileHeader;
